import { FC } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { ChevronRightIcon } from '@treams/treams-icons';

export type DeltaState = 'increase' | 'decline' | 'neutral';

const Delta = styled(Flex)<{ deltaState: DeltaState }>`
	color: ${(props) => props.deltaState === 'increase' && props.theme.colors.green};
	color: ${(props) => props.deltaState === 'decline' && props.theme.colors.red};
	color: ${(props) => props.deltaState === 'neutral' && props.theme.colors.darkGray};
`;

const Arrow = styled(Box)<{ deltaState: DeltaState }>`
	svg {
		display: block;
		width: 24px;
		height: 24px;

		transform: rotate(${(props) => props.deltaState === 'increase' && -90}deg);
		transform: rotate(${(props) => props.deltaState === 'decline' && 90}deg);
		transform: rotate(${(props) => props.deltaState === 'neutral' && 0}deg);

		path {
			fill: ${(props) => props.deltaState === 'increase' && props.theme.colors.green};
			fill: ${(props) => props.deltaState === 'decline' && props.theme.colors.red};
			fill: ${(props) => props.deltaState === 'neutral' && props.theme.colors.darkGray};
		}
	}
`;

type Props = {
	delta: number | null;
};

export const EngagementDelta: FC<Props> = ({ delta }) => {
	let deltaState: DeltaState = 'neutral';

	if (delta) {
		deltaState = delta > 0 ? 'increase' : 'decline';
	}

	return (
		<Delta ml={4} alignItems="center" flexGrow={0} flexShrink={0} deltaState={deltaState}>
			<Box flexGrow={0} flexShrink={0}>
				{Math.abs(delta ?? 0).toFixed(1)}
			</Box>

			<Arrow deltaState={deltaState}>
				<ChevronRightIcon />
			</Arrow>
		</Delta>
	);
};
